import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-indicator-trigger-api",
  "use": "icon-indicator-trigger-api-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-indicator-trigger-api\"><path fill-rule=\"evenodd\" d=\"M22.5 4a4.5 4.5 0 1 1-.479 8.975l-2.145 3.13 1.95 2.945q.33-.05.674-.05a4.5 4.5 0 1 1-3.952 2.345L16.334 18h-3.59A4.502 4.502 0 0 1 4 16.5a4.5 4.5 0 0 1 8.242-2.5h4.228l2.176-3.176A4.5 4.5 0 0 1 22.5 4\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol